import { render, staticRenderFns } from "./CreatureType.vue?vue&type=template&id=dab3597a&"
import script from "./CreatureType.vue?vue&type=script&lang=js&"
export * from "./CreatureType.vue?vue&type=script&lang=js&"
import style0 from "./CreatureType.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports